<template>
  <b-sidebar
    id="sidebar-create"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ $t(lang.id ? 'Update': 'Create') }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="clear(hide)"
        />

      </div>

      <!-- Body -->
      <b-form
        class="p-2"
        @submit.prevent
      >
        <validation-observer ref="form">
          <!-- Uz Name -->
          <b-form-group
            :label="$t('Name')"
            label-for="name"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Name')"
              rules="required"
            >
              <b-form-input
                id="name"
                v-model="lang.name"
                trim
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <b-form-group
            :label="$t('Status')"
            label-for="status"
          >
            <validation-provider
              #default="{ errors }"
              :name="$t('Status')"
            >
              <b-form-checkbox
                v-model="lang.status"
                value="100"
                unchecked-value="200"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              @click="submit(hide)"
            >
              {{ lang.id ? $t('Update') : $t('Create') }}
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="clear(hide)"
            >
              {{ $t('Cancel') }}
            </b-button>
          </div>
        </validation-observer>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BButton, BFormCheckbox,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ValidationProvider, ValidationObserver } from 'vee-validate'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormCheckbox,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
  },
  directives: {
    Ripple,
  },
  computed: {
    lang: {
      get() {
        return this.$store.state[this.MODULE_NAME].lang
      },
      set(data) {
        this.$store.commit(`${this.MODULE_NAME}/UPDATE`, data)
      },
    },
  },
  methods: {
    clear(hide) {
      this.$store.commit(`${this.MODULE_NAME}/FRESH`)
      hide()
    },
    submit(hide) {
      this.$refs.form.validate().then(success => {
        if (success) {
          this.$createSwal(this, this.lang, `${this.MODULE_NAME}/${this.lang.id ? 'update' : 'create'}`, () => {
            this.$emit('refetchData')
            this.$store.commit(`${this.MODULE_NAME}/FRESH`)
          })
          hide()
        }
      })
    },
  },
  setup() {
    const MODULE_NAME = 'certificate'
    return {
      MODULE_NAME,
    }
  },
}
</script>
